import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { NumberingQuery, NumberingQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(NumberingQuery)
@Wrapper(NumberingQueryHandlerBase)
export class NumberingQueryHandler {
    public constructor(
        http: Http,
    ) { }
}
